function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import toNumber from 'lodash/toNumber';
import MetricConversions from 'libs/MetricConversions';
import App from 'modules/App';
import Account from 'modules/Account';
import Locked from 'components/Locked';
import * as constants from '../../constants';
import messages from '../../messages';
import TargetsPicker from './TargetsPicker';
import styles from './GlucoseLevelTargets.pcss';
var _React_PureComponent;
class GlucoseLevelTargets extends (_React_PureComponent = React.PureComponent) {
    onSetValue(input) {
        const { id, value } = input;
        const { unit } = this.conversion;
        const precision = get(App.constants.GLUCOSE_LEVELS_INPUTS_PRECISION, unit, 0);
        const roundedValue = isNumber(value) ? toNumber(value.toFixed(precision)) : value;
        this.props.onSetFormValue({
            id,
            value: roundedValue
        });
    }
    onLockedClick() {
        this.setState((prevState)=>({
                isLocked: !prevState.isLocked
            }));
    }
    renderTargetRangeHeader(message) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, message)),
                ` (${this.conversion.unitSymbol})`
            ]
        });
    }
    render() {
        const { isDisabled, countrySettings, activeClinicMembership, phiSet, patient = {}, withLocked } = this.props;
        const { isLocked } = this.state;
        const { unit } = this.conversion;
        const precision = get(App.constants.GLUCOSE_LEVELS_INPUTS_PRECISION, unit, 0);
        const pickerProps = _object_spread({
            onRangeChange: (input)=>this.onSetValue(input),
            onTimeChange: this.props.onSetFormValue,
            formValues: this.props.formValues,
            conversion: this.conversion
        }, this.defaultValuesSliders);
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                !isDisabled && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            className: styles.headerTargetRanges,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.headers.targetRanges), {
                                values: {
                                    name: /*#__PURE__*/ _jsx("b", {
                                        children: `${patient.firstName} ${patient.lastName}`
                                    }),
                                    diabetesType: /*#__PURE__*/ _jsx("b", {
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.diabetesTypes[get(phiSet, 'diabetesType', 'NotSet')]))
                                    })
                                }
                            }))
                        }),
                        withLocked && /*#__PURE__*/ _jsx("div", {
                            className: styles.locked,
                            children: /*#__PURE__*/ _jsx(Locked, {
                                isLocked: isLocked,
                                onClick: ()=>this.onLockedClick()
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-4",
                            children: /*#__PURE__*/ _jsx(TargetsPicker, _object_spread_props(_object_spread({
                                header: this.renderTargetRangeHeader(messages.headers.preMeal),
                                targetType: "preMeal"
                            }, pickerProps), {
                                locked: isDisabled || isLocked,
                                countrySettings: countrySettings,
                                precision: precision,
                                activeClinicMembership: activeClinicMembership,
                                phiSet: phiSet,
                                withoutOrder: true
                            }))
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-4",
                            children: /*#__PURE__*/ _jsx(TargetsPicker, _object_spread_props(_object_spread({
                                header: this.renderTargetRangeHeader(messages.headers.postMeal),
                                targetType: "postMeal"
                            }, pickerProps), {
                                locked: isDisabled || isLocked,
                                countrySettings: countrySettings,
                                precision: precision,
                                activeClinicMembership: activeClinicMembership,
                                phiSet: phiSet
                            }))
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-4",
                            children: /*#__PURE__*/ _jsx(TargetsPicker, _object_spread_props(_object_spread({
                                header: this.renderTargetRangeHeader(messages.headers.critical),
                                targetType: "critical"
                            }, pickerProps), {
                                locked: isDisabled || isLocked,
                                countrySettings: countrySettings,
                                precision: precision,
                                activeClinicMembership: activeClinicMembership,
                                phiSet: phiSet
                            }))
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        const metricConversions = new MetricConversions(props.metricsUnits);
        this.conversion = metricConversions.bloodGlucoseConcentration;
        const { unit } = this.conversion;
        this.defaultValuesSliders = {
            valueMin: 0,
            valueMax: unit === 'MMOL_L' ? 20 : 350,
            valueStep: unit === 'MMOL_L' ? 2.5 : 50,
            valueDragStep: unit === 'MMOL_L' ? 0.1 : 1
        };
        this.state = {
            isLocked: props.withLocked
        };
    }
}
_define_property(GlucoseLevelTargets, "propTypes", {
    // Temporary flag to be determined with UX team
    withLocked: PropTypes.bool,
    // Explicit props
    isDisabled: PropTypes.bool,
    phiSet: PropTypes.object,
    patient: PropTypes.object,
    // Implicit props
    metricsUnits: PropTypes.object,
    formValues: PropTypes.object,
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    countrySettings: PropTypes.object,
    activeClinicMembership: Account.shapes.clinicMembership,
    // Implicit actions
    onSetFormValue: PropTypes.func.isRequired,
    onFormErrors: PropTypes.func.isRequired,
    onClearForm: PropTypes.func
});
_define_property(GlucoseLevelTargets, "defaultProps", {
    withLocked: false
});
const mapStateToProps = (state)=>{
    const formName = constants.PATIENT_GLUCOSE_SETTINGS_FORM;
    return {
        metricsUnits: Account.selectors.metricsUnits(state),
        countrySettings: Account.selectors.countrySettings(state),
        formValues: App.selectors.formSelector(formName)(state),
        featureToggles: App.selectors.featureToggles(state)
    };
};
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.PATIENT_GLUCOSE_SETTINGS_FORM;
    return {
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedGlucoseLevelTargets = connect(mapStateToProps, mapDispatchToProps)(GlucoseLevelTargets);
export default withStyles(styles)(ConnectedGlucoseLevelTargets);
